
export const  isoPad = (n) => {
  if (n<0) {
    n = Math.abs(n);
    return (n < 10) ? ("-0" + n) : "-" + n;
  }
  return (n < 10) ? ("+0" + n) : "+" + n;
}




function gcd (a,b) {
  a = Math.abs(a);
  b = Math.abs(b);

  if( a < b) {
    var temp = b;
    b = a;
    a = temp;
  }
  
  if( b === 0) return a;

  let r = a % b;
  while(r > 0) {
      a = b;
      b = r;
      r = a % b;
  }

  if (a === 95) {
  }
  return b;
}

function simplify(num,den) {
  num = Math.round(num, 0);
  let g = gcd(num,den);
  return [ Math.round(num/g, 0) , Math.round(den/g, 0) ];
}

export function toFractional(num) {
  let temp = ((num - 1.00) * 100);
  temp = simplify(temp, 100);
  let result = temp[0] + '/' + temp[1];
  return result;
}

export function toMoneyLine(num) {
  let result = num;
  if (num >= 2.00) {
    result = Math.round((num - 1) * 100);
    }
  else {
    if ((num - 1) !== 0) {
      result = Math.round(-100 / (num -1));
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/helpers.js